<template>
	<div class="login-container" >
		<div class="appheader">
			<div class="w">
				<div class="logo" @click="goHome" >
					<img :src="contact.logo"  width="170" />
				</div>
			</div>
		</div>
		<div class="content">
			<div class="lf-cover">
				<img src="../../assets/green.jpg">
			</div>
			<div class="form">
                <div class="form-wrap">
                	<div class="form-title">Sign Up</div>

                    <el-form ref="form" :model="formData" label-width="0">
						<el-form-item >
							<div class="label-item">
					    	 Email
					        </div>
						    <el-input v-model="formData.email" ></el-input>
						</el-form-item>
						<el-form-item >
							<div class="label-item">
					    	 Password
					        </div>
						    <el-input type="password"  v-model="formData.password" ></el-input>
						</el-form-item>
				    </el-form>

					<div class="form-item clear-border forget-cipher">
						<div @click="facelogin">
							<img src="../../assets/facebook.png"><span>FaceBook Login</span>
						</div>
						<span @click="$router.push('/forget')">Forget password</span>
					</div>

					<div class="form-item btn-group clear-border">

						
                        <el-button type="success" class="btn login-btn" :loading="loading" @click="login" >Log In</el-button>

                        <el-button type="text" class="btn cancel-btn" @click="goReg">No account ? <i>Creat an account.</i></el-button>

					
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

	import {
		mapState
	} from 'vuex'
	import { Toast } from 'vant';

	import hello from "hellojs/dist/hello.all"



	export default {
		data() {

			return {
				appid: "wx31d2a9d56ff42e3d",
				scope: "snsapi_login",
				loading: false,
				formData: {
					email:"",
					emailplaceholder: "",
					password: ""
				},
				type: 1, // 1 密码登录 2 微信扫码
				timeOut: null,
				t: 60
			}
		},
		watch: {
			$route: {
           		handler: function(val, oldVal) {  

				},
				deep: true
			}
		},
		components: {

		},
		computed: {
			...mapState({
				contact: state => state.contact,
			}),
		},
		 beforeCreate () {
		       
		       hello.init({
		          "facebook":"1290651494650036"
		       },{
		         redirect_uri:window.location.href
		       })
		  },
		mounted() {
			 var app = this;

			 this.$store.dispatch('SET_BIND',{});

			 var code = this.$route.query.code

            if( code && !this._isMobile()){


					this.$api("/login/WeChatLogin", {

						code

					}).then(function(res) {

						if (res.status == "200") {

							app.$store.dispatch('SET_USER', res.data.user);
							app.$store.dispatch('SET_TOKEN', res.data.access_token);
							app.pageGo(app);


						} else if (res.status == "406") {

							app.$store.dispatch('SET_BIND', res.data);

							app.$router.replace("/register");
						}

					})


            }
 
            if(code && this._isMobile()){


			    this.$api("/login/mWeChatLogin", {
						code
				}).then(function(res) {

					if (res.status == "200") {

						app.$store.dispatch('SET_USER', res.data.user);
						app.$store.dispatch('SET_TOKEN', res.data.access_token);
						app.pageGo(app)

					} else if (res.status == "406") {

						app.$store.dispatch('SET_BIND', res.data);

						app.$router.replace("/register");
					}

				}).catch(function(res){
						app.$router.push("/login")
				})


            }

		},
		methods: {
			 goHome(){
                  this.$router.push('/')
			 },
			 facelogin(){
		      var app = this;
		      let provider =  hello('facebook') 
		       provider.login().then(function(r) {
		           provider.api("me").then(function(res){

	                	app.$api("/login/index", {open_id:res.id}).then(function(res) {

							if (res.status == "200") {
								
								app.$store.dispatch('SET_USER', res.data.user);
								app.$store.dispatch('SET_TOKEN', res.data.access_token);
								app.pageGo(app)

							} else if (res.status == "406") {

								app.$store.dispatch('SET_BIND', res.data);
								app.$router.push("/register")
							}

						})     
		           })
		        }, function(e) {
		        
		        });

		    },
			goReg(){
				this.$store.dispatch('SET_BIND',{});
				this.$router.replace('/register');
			},
			_isMobile() {
				 let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
				 return flag;
			},
			pageGo(app){

               setTimeout(function() {
               	   var url = app.$api2.getGhStorageItem("url");
               	   if(url){
               	   	   location.replace(url);
               	   }else{
               	   	 app.$router.push('/');
               	   }
			   }, 1000)

			},
			login() {
				var app = this;
				app.loading = true;

				this.$api("/login/index", this.formData).then(function(res) {
					app.loading = false;
					if (res.status == "200") {
						app.global_variable.showToast(res.msg)
						app.$store.dispatch('SET_USER', res.data.user);
						app.$store.dispatch('SET_TOKEN', res.data.access_token);
						app.pageGo(app)
					}

				})
			},
			getCode() {
				var {
					t
				} = this
				if (t <= 60) {
					return
				}
				var num = t;

				--num
				this.t = num;
				this.timeOut = setInterval(() => {
					--num
					if (num <= 0) {
						this.t = 61;
						clearInterval(this.timeOut);
						return
					}
					this.t = num
				}, 1000)

			}
		}
	}
</script>

<style lang="less" >


	.web-login{
	    display: flex;
	    align-items: center;
	    justify-content: center;
	    margin-top:10%;
	    span{
           width:20%;
           height: 1px;
           background: #ddd;
	    }
	    img{
	    	width:30px;
	    	height:30px;
	    	margin:0 10px;
	    }
	}
</style>



// WEBPACK FOOTER //
// src/pages/login/login.vue